import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  marketMakerOrders: [],
  loading: false,
  error: null,
};

const marketMakerOrdersSlice = createSlice({
  name: 'marketMakerOrders',
  initialState,
  reducers: {
    addMarketMakerOrder: (state, action) => {
      state.marketMakerOrders.push(action.payload);
    },
    updateMarketMakerOrder: (state, action) => {
      const { id, updates } = action.payload;
      const orderIndex = state.marketMakerOrders.findIndex(order => order.id === id);
      if (orderIndex !== -1) {
        state.marketMakerOrders[orderIndex] = { ...state.marketMakerOrders[orderIndex], ...updates };
      }
    },
    removeMarketMakerOrder: (state, action) => {
      state.marketMakerOrders = state.marketMakerOrders.filter(order => order.id !== action.payload);
    },
    setMarketMakerOrders: (state, action) => {
      state.marketMakerOrders = action.payload;
    },
    clearMarketMakerOrders: (state) => {
      state.marketMakerOrders = [];
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  addMarketMakerOrder,
  updateMarketMakerOrder,
  removeMarketMakerOrder,
  setMarketMakerOrders,
  clearMarketMakerOrders,
  setLoading,
  setError,
} = marketMakerOrdersSlice.actions;

// Selectors
export const selectAllMarketMakerOrders = (state) => state.marketMakerOrders.marketMakerOrders;
export const selectMarketMakerOrderById = (state, id) => 
  state.marketMakerOrders.marketMakerOrders.find(order => order.id === id);
export const selectMarketMakerOrdersLoading = (state) => state.marketMakerOrders.loading;
export const selectMarketMakerOrdersError = (state) => state.marketMakerOrders.error;
export const selectMarketMakerOrdersCount = (state) => state.marketMakerOrders.marketMakerOrders.length;

// Filtered selectors
export const selectMarketMakerOrdersByType = (state, type) => 
  state.marketMakerOrders.marketMakerOrders.filter(order => order.type === type);

export const selectMarketMakerOrdersByEntity = (state, entityId) => 
  state.marketMakerOrders.marketMakerOrders.filter(order => order.entityId === entityId);

export const selectMarketMakerOrdersByStatus = (state, status) => 
  state.marketMakerOrders.marketMakerOrders.filter(order => order.status === status);

// Summary selectors
export const selectMarketMakerBuyOrders = (state) => 
  state.marketMakerOrders.marketMakerOrders.filter(order => order.type === 'buy');

export const selectMarketMakerSellOrders = (state) => 
  state.marketMakerOrders.marketMakerOrders.filter(order => order.type === 'sell');

export const selectMarketMakerOrdersSummary = (state) => {
  const orders = state.marketMakerOrders.marketMakerOrders;
  const buyOrders = orders.filter(order => order.type === 'buy');
  const sellOrders = orders.filter(order => order.type === 'sell');
  
  return {
    totalOrders: orders.length,
    buyOrders: buyOrders.length,
    sellOrders: sellOrders.length,
    totalValue: orders.reduce((total, order) => total + (order.quantity * order.price), 0),
    buyValue: buyOrders.reduce((total, order) => total + (order.quantity * order.price), 0),
    sellValue: sellOrders.reduce((total, order) => total + (order.quantity * order.price), 0),
  };
};

export default marketMakerOrdersSlice.reducer; 